// extracted by mini-css-extract-plugin
export default {"submittedByCell":"FeedbackTable_submittedByCell__ZlP-d","submittedByName":"FeedbackTable_submittedByName__yCrUV","submittedByEmail":"FeedbackTable_submittedByEmail__sBSeQ"};